import { Theme } from '@mui/material/styles';
import { CalendarEventType, CalendarEventStatus } from './calendar.types';

/**
 * Get the color for a calendar event type
 */
export const getEventTypeColor = (type: string, theme: Theme): string => {
  switch (type) {
    case CalendarEventType.MEETING:
      return theme.palette.primary.main;
    case CalendarEventType.TASK:
      return theme.palette.warning.main;
    case CalendarEventType.REMINDER:
      return theme.palette.success.main;
    case CalendarEventType.EVENT_BOOKING:
      return theme.palette.secondary.main;
    default:
      return theme.palette.grey[500];
  }
};

/**
 * Get the color for a calendar event status
 */
export const getEventStatusColor = (status: string, theme: Theme): string => {
  switch (status) {
    case CalendarEventStatus.SCHEDULED:
      return theme.palette.success.main;
    case CalendarEventStatus.CANCELLED:
      return theme.palette.error.main;
    case CalendarEventStatus.COMPLETED:
      return theme.palette.info.main;
    default:
      return theme.palette.grey[500];
  }
};
